import { FlowContext } from 'src/lib/flow';
import { newFlowPage } from 'src/lib/flow/FlowPage';
import { addPageLoader } from 'src/lib/flow/loaders';
import { sellerGlobalPagePath } from 'src/routes/pathBuilders';
import { updateAnswersCompleted } from 'src/store/apiUtils';
import { getFlowFromState } from 'src/store/flow_listeners';

import { isAgent, isWorkingWithHomebuilder } from '../../../../lib/flow/pageHelpers';

const partnerListedPage = newFlowPage({
  slug: 'partner-listed',
  autoAdvance: true,
  title: 'Is this home currently listed on the market (MLS)?',
  isEnabled: ({
    answers,
    inputContext: { isInPartnershipExpansionDenial, channel },
  }: FlowContext) => {
    return (
      isInPartnershipExpansionDenial &&
      answers['seller.relation_to_owner'] === 'Self' &&
      answers['seller.working_with_home_builder'] !== true &&
      !isAgent(answers, channel)
    );
  },
  questions: [
    {
      key: 'seller.listed',
      type: 'radio_single_select',
      options: [
        {
          label: 'Yes',
          value: 'true',
        },
        {
          label: 'No',
          value: 'false',
        },
      ],
    },
  ],
  exitPath: ({
    inputContext: {
      sellerInputUUID,
      isInPartnershipExpansionDenial,
      channel,
      homebuilderIdentifier,
    },
    answers,
  }: FlowContext) => {
    if (isInPartnershipExpansionDenial) {
      if (
        !isAgent(answers, channel) &&
        !isWorkingWithHomebuilder(answers, homebuilderIdentifier) &&
        !answers['seller.listed']
      ) {
        return sellerGlobalPagePath({ token: sellerInputUUID, page: 'complete-partner' });
      }
      return sellerGlobalPagePath({ token: sellerInputUUID, page: 'unavailable' });
    }
    return null;
  },
});

addPageLoader('partner-listed', 'wait-for-update', async (listenerApi) => {
  // wait for submit answers to complete

  // if the user has set any eligibility criteria, we need to wait until the answers complete
  // to see if they have been denied so we have updated data for isInPartnershipExpansionDenial
  const appState = listenerApi.getState();
  const { context } = getFlowFromState(appState);
  if (typeof context.answers['home.eligibility_criteria'] === 'object') {
    const eligibilityCriteria = Object.entries(context.answers['home.eligibility_criteria'])
      .filter(([_key, value]) => !!value)
      .map(([key]) => key);
    if (
      Array.isArray(eligibilityCriteria) &&
      eligibilityCriteria.length &&
      !eligibilityCriteria.includes('_none_')
    ) {
      await updateAnswersCompleted(listenerApi);
    }
  }
});

export default partnerListedPage;
